// API
import { useQuery } from "react-query"
import { Api } from "./api"

// Components
import { FetchingStatus } from "components"
import { FormSection } from "./components"

export default function WalkInReservation() {
  // API
  const fetch = useQuery(['list', 'category'], Api.category)

  return (
    <div className="container mt-3">
      <h4 className="text-center fw-bold">WALK IN RESERVATION</h4>

      {fetch.isLoading || fetch.isError ? (
        <FetchingStatus loading={fetch.isLoading} />
      ) : (
        <FormSection data={fetch.data} />
      )}
    </div>
  )
}